import type { TealiumEventData } from 'src/types/trackingData';

import type { TRACKING_ORIGIN } from '../constants/headerFooterTracking';

export const getHeaderFooterInteraction = (
  trackingEvent: string,
  actionOrigin: TRACKING_ORIGIN,
): TealiumEventData => ({
  actionOrigin,
  linkName: trackingEvent,
  eventName: [trackingEvent],
});
